export enum SectionSummaryAssessmentsEnum {
    published  = 1,
    ongoing  = 2,
    finished  = 3,
    resultPublished  = 4
  }
  